module.exports = __webpack_public_path__ + "static/media/tips-fran-oss.4f279dd9.svg";